import axios from "axios";
import { apiConfig } from "./apiConfig";

export default axios.create({
  baseURL: apiConfig.baseUrl,
  headers: apiConfig.headers,
  withCredentials: true,
  withXSRFToken: true,
});
